import { useParams } from "react-router-dom";
import { formatDateAndTime, formatWord } from "../../../../Utils/utils";

const ViewPrescription = (props: any) => {
  const { viewPrescription } = props;
  const v = viewPrescription;
  const { id } = useParams();

  return (
    <div className="p-2" style={{ maxHeight: "80vh", overflowY: "auto" }}>
      <div className="d-flex flex-column gap-1">
        <span className="f-18 fw-500 fw-bold">
          {v?.prescriptionTitle
            ? formatWord(v?.prescriptionTitle)
            : "Prescription"}
        </span>
        <span className="f-14 fw-400" style={{ color: "#696969" }}>
          {formatDateAndTime(v?.createdAt)}
        </span>
      </div>

      <div className="row">
        {/* ✅ VITALS SECTION */}
        {(v?.bloodPressure ||
          v?.pulseRate ||
          v?.allergy ||
          v?.history ||
          v?.investigations ||
          v?.notes) && (
          <>
            <span className="prescription-headline ms-2 col-12 rounded mb-3 mt-2">
              Vitals
            </span>

            {/* Row 1: Pulse + BP */}
            <div className="d-flex gap-4 flex-wrap">
              {v?.pulseRate && (
                <div className="d-flex flex-column gap-2">
                  <span className="f-14 fw-500 fw-bold">Pulse Rate</span>
                  <span>{`${v?.pulseRate} bpm`}</span>
                </div>
              )}
              {v?.bloodPressure && (
                <div className="d-flex flex-column gap-2">
                  <span className="f-14 fw-500 fw-bold">Blood Pressure</span>
                  <span>{`${v?.bloodPressure}`}</span>
                </div>
              )}
            </div>

            {/* Row 2: Allergy, History, Investigations, Notes */}
            <div className="d-flex gap-4 flex-wrap mt-3">
              {v?.allergy && (
                <div className="d-flex flex-column gap-2">
                  <span className="f-14 fw-500 fw-bold">Allergy</span>
                  <span>{v?.allergy}</span>
                </div>
              )}
              {v?.history && (
                <div className="d-flex flex-column gap-2">
                  <span className="f-14 fw-500 fw-bold">History</span>
                  <span>{v?.history}</span>
                </div>
              )}
              {v?.investigations && (
                <div className="d-flex flex-column gap-2">
                  <span className="f-14 fw-500 fw-bold">Investigations</span>
                  <span>{v?.investigations}</span>
                </div>
              )}
              {v?.notes && (
                <div className="d-flex flex-column gap-2">
                  <span className="f-14 fw-500 fw-bold">Notes</span>
                  <span>{v?.notes}</span>
                </div>
              )}
            </div>
          </>
        )}

        {/* ✅ COMPLAINTS */}
        {v?.complaints && (
          <>
            <span className="prescription-headline col-12 ms-2 rounded mt-3">
              Complaints
            </span>
            <div className="mt-2">
              <span style={{ color: "#808080" }}>
                <i>{formatWord(v?.complaints)}</i>
              </span>
            </div>
          </>
        )}

        {/* ✅ TESTS */}
        {v?.prescriptionTest?.length > 0 && (
          <>
            <span className="prescription-headline col-12 ms-2 rounded mt-3">
              Tests
            </span>
            <div className="mt-3 d-flex gap-2 flex-wrap">
              {v?.prescriptionTest?.map((t: any) => (
                <span
                  style={{ backgroundColor: "#EBEBEB" }}
                  className="p-2 rounded"
                  key={t?.testId}
                >
                  <span className="f-14 fw-400">{t?.testName}</span> -
                  {t?.priorityLevel === "urgent" ? (
                    <span className="urgent rounded-pill p-1 ms-2">
                      {t?.priorityLevel}
                    </span>
                  ) : (
                    <span className="routine rounded-pill p-1 ms-2">
                      {t?.priorityLevel}
                    </span>
                  )}
                </span>
              ))}
            </div>
          </>
        )}

        {/* ✅ H&E */}
        {v?.hematoxylinEosins && (
          <>
            <span className="prescription-headline ms-2 col-12 rounded mt-3">
              H & E
            </span>
            <div className="mt-2">
              <span style={{ color: "#808080" }}>
                <i>{formatWord(v?.hematoxylinEosins)}</i>
              </span>
            </div>
          </>
        )}

        {/* ✅ MEDICINES */}
        {v?.prescriptionMaster?.length > 0 && (
          <>
            <span className="prescription-headline ms-2 col-12 rounded mt-3">
              Medicines
            </span>
            <table className="table overflow-auto">
              <thead>
                <tr>
                  <th>Medicine</th>
                  <th>Strength</th>
                  <th>Frequency</th>
                  <th>Intake</th>
                  <th>Days</th>
                </tr>
              </thead>
              <tbody>
                {v?.prescriptionMaster?.map((item: any, index: number) => (
                  <tr key={index}>
                    <td>{item?.medicineName || "N/A"}</td>
                    <td>{item?.medicineDosage || "N/A"}</td>

                    {/* ✅ SAFE FREQUENCY PARSING */}
                    <td>
                      {item?.medicineIntake ? (() => {
                        let parsedIntake = [];

                        try {
                          const temp =
                            typeof item.medicineIntake === "string"
                              ? JSON.parse(item.medicineIntake)
                              : item.medicineIntake;

                          parsedIntake = Array.isArray(temp) ? temp : [temp];
                        } catch {
                          parsedIntake = [item.medicineIntake];
                        }

                        return parsedIntake.map((intake: string, idx: number) => {
                          let content;
                          if (intake === "Morning") content = "M";
                          else if (intake === "Afternoon") content = "AN";
                          else if (intake === "Night") content = "N";
                          else content = intake;

                          return (
                            <span key={idx}>
                              <span className="intake p-1 rounded-pill">{content}</span>
                              {idx < parsedIntake.length - 1 && ", "}
                            </span>
                          );
                        });
                      })() : (
                        <span>N/A</span>
                      )}
                    </td>

                    <td>{item?.inTake || "N/A"}</td>
                    <td>
                      {item?.medicineDays ? `${item.medicineDays} days` : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {/* ✅ ADVICE */}
        {v?.advice && (
          <>
            <span className="prescription-headline col-12 rounded mt-3">
              Advice
            </span>
            <div className="mt-2">
              <span style={{ color: "#808080" }}>
                <i>{v?.advice}</i>
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ViewPrescription;
